import React, { Fragment, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import InfoIcon from '@material-ui/icons/Info';
import { Paper, TableCell, TableHead, TableBody, TableRow, Table, TextField, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import Pagination from '../../../shared_elements/components/Pagination';
import { EmptyCollection, PageLoader } from '../../../shared_elements';
import { regexConstants } from '../../../constants/regEx';
function AssessmentList({ mainData, setAssessmentData, assessmentData, onChangeAssessment, moduleName }) {
    const [pageLoader, setPageLoader] = useState(false)
    useEffect(() => {
        if (mainData?.assessment_job_id) {
            assessmentDataApi()
        }
    }, [])

    const assessmentDataApi = (query, loader) => {
        setPageLoader(true)
        globalGetService(`camo/fleet_assessment/job_status/${mainData?.assessment_job_id}`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setPageLoader(false)
                    setAssessmentData(response?.data || [])
                }
            })
    }
      const progress = Number(assessmentData?.progress);
    return (
        <Fragment>
            {<Paper square style={{ margin: "5px 0px 5px 0px" }} elevation={4}>
                <div className='assessment-list camo-fleet-module' style={{ height: (window.innerHeight - 250) + 'px' }}>
                    <Table stickyHeader={true}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Module</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Part Number</TableCell>
                                <TableCell>Serial Number</TableCell>
                                <TableCell>ESN</TableCell>
                                <TableCell>{moduleName === "sb" ? "SB" : "AD"} Compliance</TableCell>
                                <TableCell>Reduced Limit <Tooltip title="Reduced Limit only for LLP and Soft Time" placement="top"><InfoIcon size='small' style={{ verticalAlign: 'middle', fontSize: "small", paddingLeft: '3px' }} /></Tooltip></TableCell>
                                <TableCell>Remarks</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assessmentData?.result?.length > 0 && assessmentData?.result?.map((item, index) =>
                                <TableRow key={index}>
                                    <TableCell >{item?.module || '--'}</TableCell>
                                    <TableCell >{item?.description || '--'}</TableCell>
                                    <TableCell >{item.part_number || '--'}</TableCell>
                                    <TableCell >{item?.serial_number || '--'}</TableCell>
                                    <TableCell >{item?.esn || '--'}</TableCell>
                                    <TableCell style={{ minWidth: '220px' }}>{item?.assessment_remarks === 'NA' ? '--' :
                                        <Autocomplete
                                            id={moduleName === "sb" ? "sb_compliance_status" : "ad_compliance_status"}
                                            options={['OPEN', 'COMPLIED', 'PARTIALLY COMPLIED', 'NOT APPLICABLE']}
                                            getOptionLabel={option => option}
                                            margin='normal'
                                            value={moduleName === "sb" ? item?.sb_compliance_status : item?.ad_compliance_status || null}
                                            disabled={
                                                mainData?.ad_assessment_status === "COMPLETED" ||
                                                mainData?.sb_assessment_status === "COMPLETED" ||
                                                (
                                                    item?.esn &&
                                                    assessmentData?.result?.some((row, i) => {
                                                        const complianceKey = moduleName === "sb"
                                                            ? "sb_compliance_status"
                                                            : "ad_compliance_status";
                                                        return (
                                                            row.esn === item.esn &&
                                                            row[complianceKey] &&     // already selected somewhere
                                                            i !== index              // not current row
                                                        );
                                                    })
                                                )
                                            }
                                            onChange={(e, value) => onChangeAssessment(moduleName === "sb" ? "sb_compliance_status" : "ad_compliance_status", value, index)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Compliance Status"
                                                    fullWidth
                                                    margin='normal'
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />}
                                    </TableCell>
                                    <TableCell >
                                        {item?.module === 'LLP' || item?.module === 'Soft Time' ?
                                            <TextField
                                                margin='normal'
                                                name="reduced_limit"
                                                inputProps={{ maxLength: 5 }}
                                                fullWidth
                                                value={item?.reduced_limit || ''}
                                                InputLabelProps={{ shrink: true }}
                                                disabled={(mainData?.ad_assessment_status === "COMPLETED" || mainData?.sb_assessment_status === "COMPLETED") ? true : (item?.module === 'LLP' || item?.module === 'Soft Time') ? false : true}
                                                onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onChangeAssessment('reduced_limit', e.target.value ? e.target.value : null, index) : e.preventDefault() }}
                                            /> : '--'}
                                    </TableCell>
                                    <TableCell >{item?.assessment_remarks || '--'}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    {!assessmentData?.result?.length ? <EmptyCollection description={progress === 100 && !assessmentData?.result?.length ? 'Entered Part number,Serial number not matched in our system':'Assessment result are being fetched ...please wait'} /> : null}
                </div>
                <Pagination
                    pagination={assessmentData?.pagination}
                    onChangePage={(event, newPage) => assessmentDataApi({ page: newPage + 1, per_page: assessmentData?.pagination?.per_page || 20 }, 'pageLoader')}
                    onChangeRowsPerPage={(event) => assessmentDataApi({ page: 1, per_page: event.target.value }, 'pageLoader')}
                />
            </Paper>}
            {pageLoader ? <PageLoader /> : null}
        </Fragment >
    )
}

export default withRouter(AssessmentList)